(() => {
  const selector = '.product__content .trustpilot-widget';
  const prepared = new WeakSet();
  let loading;
  function bootstrap() {
    if (window.Trustpilot?.loadFromElement) return Promise.resolve(window.Trustpilot);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[src*="tp.widget.bootstrap.min.js"]');
      const script = existing || document.createElement('script');
      const finish = () => window.Trustpilot?.loadFromElement ? resolve(window.Trustpilot) : reject();
      script.addEventListener('load', finish, { once: true });
      script.addEventListener('error', reject, { once: true });
      if (!existing) {
        script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.async = true;
        document.head.append(script);
      }
      setTimeout(() => window.Trustpilot?.loadFromElement ? resolve(window.Trustpilot) : reject(), 10000);
    }).catch(() => { loading = null; return null; });
    return loading;
  }
  async function integrate() {
    const widgets = Array.from(document.querySelectorAll(selector)).filter(el => !prepared.has(el));
    if (!widgets.length) return;
    widgets.forEach(el => {
      prepared.add(el);
      const locales = { it: 'it-IT', en: 'en-GB', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', nl: 'nl-NL', pt: 'pt-PT', pl: 'pl-PL' };
      el.dataset.locale = locales[el.dataset.locale] || el.dataset.locale;
      el.dataset.styleAlignment = document.documentElement.dir === 'rtl' ? 'right' : 'left';
      el.dataset.styleHeight = '60px';
      el.dataset.styleWidth = '100%';
    });
    const api = await bootstrap();
    if (!api) { widgets.forEach(el => prepared.delete(el)); return; }
    widgets.forEach(el => { if (el.isConnected) api.loadFromElement(el, true); });
  }
  let scheduled = false;
  const queue = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; integrate(); });
  };
  queue();
  document.addEventListener('shopify:section:load', queue);
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
      (node.matches('.trustpilot-widget, .product__content') || node.querySelector('.trustpilot-widget'))))) queue();
  }).observe(main, { childList: true, subtree: true });
})();

/* Floating buttons (WhatsApp, Beauty Club, -10%): one tidy column at the bottom right, same size, always visible.
   They only step aside when something covers them (cookie banner, an open form or dialog) and move up above the sticky add-to-cart bar. */
(() => {
  const root = document.documentElement;
  const styled = new WeakSet();
  const observed = new WeakSet();
  const resizeObserver = new ResizeObserver(queue);
  let queued = false;
  const SIZE = 48;
  const GAP = 10;
  const EDGE = 16;
  const slot = index => `calc(${EDGE + index * (SIZE + GAP)}px + env(safe-area-inset-bottom,0px) + var(--enzo-float-offset,0px))`;
  const page = document.createElement('style');
  page.textContent = `.enzo-refined :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container){right:${EDGE}px!important;bottom:${slot(1)}!important}`;
  document.head.append(page);
  const visible = el => {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    const style = getComputedStyle(el);
    return rect.width > 0 && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  };
  const movement = `transition:opacity 160ms ease-out;`;
  const shared = `
    :host([data-enzo-covered]) .gty-wacb-wrapper,
    :host([data-enzo-covered]) [data-current-step="tease"] {opacity:0!important;pointer-events:none!important}
    @media(prefers-reduced-motion:reduce){.gty-wacb-wrapper,[data-current-step="tease"]{transition:none!important}}
  `;
  function install(host, css) {
    if (!host?.shadowRoot || styled.has(host.shadowRoot)) return;
    const style = document.createElement('style');
    style.textContent = css + shared;
    host.shadowRoot.append(style);
    styled.add(host.shadowRoot);
    new MutationObserver(queue).observe(host.shadowRoot, {childList:true, subtree:true, attributes:true, attributeFilter:['data-current-step']});
  }
  function update() {
    queued = false;
    const wa = document.querySelector('gty-whatsapp-chat-button');
    const forms = document.querySelector('#app-embed-container-428991');
    install(wa, `
      .gty-wacb-wrapper{right:${EDGE}px!important;bottom:${slot(0)}!important;transform:none!important;z-index:90!important;${movement}}
      .gty-wacb-button{width:${SIZE}px!important;height:${SIZE}px!important;min-width:${SIZE}px!important;min-height:${SIZE}px!important;border-radius:50%!important;background:#485b4b!important;color:#fff!important;box-shadow:none!important}
      .gty-wacb-button svg{width:24px!important;height:24px!important}
      .gty-wacb-button:focus-visible{outline:2px solid #485b4b;outline-offset:4px}
    `);
    install(forms, `
      [data-current-step="tease"]{left:auto!important;right:${EDGE}px!important;bottom:${slot(2)}!important;padding:0!important;width:${SIZE}px!important;z-index:90!important;${movement}}
      [data-testid="form-teaser"]{box-sizing:border-box!important;width:${SIZE}px!important;height:${SIZE}px!important;min-width:${SIZE}px!important;min-height:${SIZE}px!important;padding:0!important;border:0!important;border-radius:50%!important;background:#485b4b!important;color:#fff!important;box-shadow:none!important;display:flex!important;align-items:center!important;justify-content:center!important}
      [data-testid="form-teaser"] h3{font-size:13px!important;font-weight:500!important;line-height:1!important;color:#fff!important;margin:0!important;padding:0!important}
      [data-testid="form-teaser"] [role="button"]{display:none!important}
      [data-testid="form-teaser"]:focus-visible{outline:2px solid #485b4b;outline-offset:4px}
    `);
    const sticky = document.querySelector('product-sticky-atc');
    if (sticky && !observed.has(sticky)) {
      observed.add(sticky);
      resizeObserver.observe(sticky);
      new MutationObserver(queue).observe(sticky, {attributes:true, childList:true, subtree:true, attributeFilter:['style', 'class']});
    }
    const dialogs = [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')];
    dialogs.forEach(dialog => {
      if (observed.has(dialog)) return;
      observed.add(dialog);
      new MutationObserver(queue).observe(dialog, {attributes:true, attributeFilter:['aria-hidden', 'open', 'class', 'style']});
    });
    const dialogOpen = dialogs.some(el => el.getAttribute('aria-hidden') === 'false' && visible(el));
    const offset = visible(sticky) ? Math.max(0, innerHeight - sticky.getBoundingClientRect().top) : 0;
    root.style.setProperty('--enzo-float-offset', `${Math.ceil(offset)}px`);
    const cookie = visible(document.querySelector('#shopify-pc__banner')) || visible(document.querySelector('#shopify-pc__prefs'));
    const form = forms?.shadowRoot?.querySelector('[data-current-step]');
    const formOpen = visible(form) && form.dataset.currentStep !== 'tease';
    root.classList.toggle('enzo-floats-covered', cookie || formOpen || dialogOpen);
    root.classList.remove('enzo-floats-scrolling');
    [wa, forms].filter(Boolean).forEach(host => {
      host.removeAttribute('data-enzo-scrolling');
      host.toggleAttribute('data-enzo-covered', cookie || dialogOpen || (host === wa && formOpen));
    });
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }
  addEventListener('scroll', queue, {passive:true});
  addEventListener('resize', queue, {passive:true});
  document.addEventListener('focusin', queue);
  document.addEventListener('shopify:section:load', queue);
  new MutationObserver(queue).observe(document.body, {childList:true, subtree:true});
  queue();
})();

(() => {
  const openers = new WeakMap();
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-enzo-quality-open]');
    if (opener) {
      const dialog = opener.closest('.enzo-quality').querySelector('.enzo-quality-dialog');
      if (!dialog || dialog.open) return;
      openers.set(dialog, opener);
      dialog.showModal();
      document.documentElement.classList.add('enzo-quality-modal-open');
      return;
    }
    const closer = event.target.closest('[data-enzo-quality-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('.enzo-quality-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('.enzo-quality-dialog')) return;
    if (!document.querySelector('.enzo-quality-dialog[open]')) document.documentElement.classList.remove('enzo-quality-modal-open');
    openers.get(event.target)?.focus({preventScroll: true});
  }, true);
})();

(() => {
  if (!document.body.classList.contains('template--brand-page') && !location.pathname.endsWith('/pages/brand')) return;
  const brands = new Set(['my-organics', 'davines', 'kydra', 'hp-firenze', 'insight', 'medavita', 'nook']);
  function markBrands() {
    document.querySelectorAll('.instant-brand-image-link').forEach(link => {
      const handle = new URL(link.href).pathname.split('/').filter(Boolean).pop();
      const name = link.closest('.instant-brand-item')?.querySelector('.instant-brand-text-link')?.textContent.trim().toLowerCase().replace(/[.\s-]/g, '');
      const namedBrand = ['myorganics', 'davines', 'kydra', 'hpfirenze', 'insight', 'medavita', 'nook'].includes(name);
      if ((!brands.has(handle) && !namedBrand) || link.parentElement.querySelector('.enzo-brand-bio')) return;
      const badge = document.createElement('span');
      badge.className = 'enzo-bio enzo-brand-bio';
      badge.textContent = 'BIO';
      link.parentElement.append(badge);
    });
  }
  markBrands();
  const main = document.querySelector('main');
  if (main) new MutationObserver(markBrands).observe(main, {childList: true, subtree: true});
})();
